/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AxiosError, AxiosRequestConfig } from 'axios';
import { createBaseErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createBaseErrorHandler';

export const createUnwrapBlobErrorHandler = () => {
    const baseActions = createBaseErrorHandler();

    return {
        ...baseActions,

        /**
         * Handles the error response returned from a LUIS API.
         *
         * @param error The error object thrown.
         * @returns A formatted Error object.
         */
        handle: async (error: AxiosError): Promise<Error> =>
            new Promise(res => {
                if (
                    (<AxiosRequestConfig>error.request)?.responseType === 'blob' &&
                    error.response.data instanceof Blob &&
                    error.response.data.type?.toLowerCase().indexOf('json') !== -1
                ) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        error.response.data = JSON.parse(<string>reader.result);
                        res(baseActions.delegate(error));
                    };

                    reader.onerror = () => {
                        res(baseActions.delegate(error));
                    };

                    reader.readAsText(error.response.data);

                    return;
                }

                res(baseActions.delegate(error));
            })
    };
};
